import React, { useEffect, useState } from 'react'
import Negocio from '../../functions/logic/Negocio'
import Spiner from '../../components/Spiner'
import { useSnackbar } from 'notistack'

export default function SeguimientoForm({ formData = {} }) {
    const baseUrl = global.IMGProd
    const [spiner, setSpiner] = useState(false)
    const { enqueueSnackbar } = useSnackbar()
    const [rastreoOrden, setRastreoOrden] = useState([])
    const [estadoSeleccionado, setEstadoSeleccionado] = useState({})
    const userToken = localStorage.getItem('userToken')
    const moduleId = localStorage.getItem('param')
    let nuevoEstado

    useEffect(() => {
        if (formData.rastreoOrden) {
            setRastreoOrden(formData.rastreoOrden)
        }
    }, [formData])

    const handleCheckboxChange = async (trackId) => {
        const nuevoEstado = !estadoSeleccionado[trackId] 
    
        setEstadoSeleccionado((prev) => ({
            ...prev,
            [trackId]: nuevoEstado
        }))
        setSpiner(true)
        await Negocio.saveChangeTrackingLogic(userToken, moduleId, trackId, nuevoEstado, formData.id)
        const response = await Negocio.getOrdenesPendientesEnvioLogic(1, 1, userToken, moduleId, formData.id, 'no')
        if (!response.error) {
            setRastreoOrden(response.orden.rastreoOrden)
            enqueueSnackbar('Información actualizada', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false)
        //await Negocio.getOrdenesLogic(1, 1, userToken, moduleId, '', formData.id, 'no')
    }
    

    return (
        <div className="container mt-4">
            <Spiner opt={spiner} />
            <div className="row">

                <div className="col-md-4">
                    <div className="card mb-3">
                        <div className="card-header">
                            <h5>Resumen de tu pedido</h5>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <strong>Subtotal IVA 15%:</strong> <span>${formData.subtotal_iva || '0.00'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>Subtotal IVA 0%:</strong> <span>${formData.subtotal_sin_iva || '0.00'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>IVA:</strong> <span>${formData.iva || '0.00'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>Envío:</strong> <span>{formData.envio ? `$${formData.envio}` : 'No seleccionado'}</span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between">
                                <h5><strong>Total:</strong></h5> <h5><strong>${formData.total || '0.00'}</strong></h5>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h5>Dirección de Envío</h5>
                        </div>
                        <div className="card-body">
                            <p><strong>Nombre</strong>{formData.checkoutAddress?.nombres + " " + formData.checkoutAddress?.apellidos || 'Nombre no disponible'}</p>
                            <p><strong>Dirección:</strong> {formData.checkoutAddress?.direccion}, {formData.checkoutAddress?.ciudad}</p>
                            <p><strong>Provincia:</strong> {formData.checkoutAddress?.provincia}, Ciudad: {formData.checkoutAddress?.ciudad}</p>
                            <p><strong>Código Postal:</strong> {formData.checkoutAddress?.codigo_postal}</p>
                            <p><strong>Teléfono:</strong> {formData.checkoutAddress?.telefono_contacto}</p>
                            <p className="text-muted">Esta es tu dirección de envío por defecto</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-header">
                            <h5>Seguimiento del Pedido</h5>
                        </div>
                        <div className="card-body">
                            {rastreoOrden.map((estado) => (
                                <div key={estado.id} className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`estado-${estado.id}`}
                                        checked={(estado.fecha_cambio && estado.status === "CONFIGH0002") || estadoSeleccionado[estado.id] || false}
                                        onChange={() => handleCheckboxChange(estado.id)}
                                        disabled={estado.fecha_cambio && estado.status === "CONFIGH0002"}
                                    />
                                    <label className="form-check-label" htmlFor={`estado-${estado.id}`}>
                                        {estado.descripcion}
                                    </label>
                                    <div className="mt-2">
                                        <p><strong>Fecha de Inicio: </strong> {estado.fecha_estado || 'No disponible'}</p>
                                        <p><strong>Fecha de Cambio: </strong> {estado.fecha_cambio || 'No disponible'}</p>

                                        <p><strong>Descripción: </strong>
                                            {estado.fecha_cambio && estado.status === "CONFIGH0002" ? estado.descripcion || 'No disponible' : ''}
                                        </p>

                                        <p><strong>Nota: </strong>
                                            {estado.fecha_cambio && estado.status === "CONFIGH0002" ? estado.notas || 'No disponible' : ''}
                                        </p>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
